<template>
  <div>
    <!--local-->
    <div class="teacher_local">
      <dl>首页 - 优秀讲师</dl>
    </div>
    <!--/local-->
    <!--高级精英讲师-->
    <div class="in_con_5">
      <div class="wrap w1200">
        <div class="in_title">
          <dl>
            <dt>高级精英讲师</dt>
            <dd>精心打造实时更新便捷的培训模式，助力企业</dd>
          </dl>
        </div>
        <div class="teacher_list_i">
          <a href="javascript:;" v-for="item in eliteTeacherList" :key="item.id" @click="teacher_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.faceUrl" :src="item.faceUrl" title="item.name"/>
                <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/teacher_normal_img.jpg" :title="item.name"/>
              </dt>
              <dd>
                <h3>{{item.name}}</h3>
                <p>{{item.content}}</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/高级精英讲师-->
    <!--全部讲师-->
    <div class="all_teacher">
      <div class="wrap w1200">
        <div class="top_tit">
          <h3>全部讲师</h3>
          <a href="javascript:;" class="study_prv" title="上一页" @click="page_click('prev')"></a>
          <a href="javascript:;" class="study_next" title="下一页" @click="page_click('next')"></a>
        </div>
        <div class="teacher_list_j">
          <a href="javascript:;" v-for="item in teacherList" :key="item.id" @click="teacher_detail(item.id)">
            <dl>
              <dt>
                <p class="header_img">
                  <img v-if="item.faceUrl" :src="item.faceUrl" title="item.name"/>
                  <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/teacher_normal_img.jpg" :title="item.name"/>
                </p>
                <p class="name_t">{{item.name}}</p>
                <p class="con_a" style="min-height: 22px;">{{item.title}}</p>
              </dt>
              <dd v-html="item.content"></dd>
            </dl>
          </a>
        </div>
      </div>

    </div>
    <!--/全部讲师-->
  </div>
</template>
<script>

export default {
  components: { },
  data () {
    return {
      filter: {
        pageNo: 1,
        pageSize: 9,
        teacherIds: [],
        delFlag: '0'
      },
      teacherList: [],
      eliteTeacherList: [],
      currentPage: 1,
      pages: 0
    }
  },
  created () {
    this.getTeachers(this.filter)
    this.getEliteTeachers()
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  computed: {},
  methods: {
    page_click (type) {
      if (type=='prev') {
        if (this.currentPage > 1) {
          this.filter.pageNo = this.currentPage - 1
          this.currentPage--
          this.getTeachers(this.filter)
        }
      } else if (type=='next') {
        if (this.currentPage < this.pages) {
          this.filter.pageNo = this.currentPage + 1
          this.currentPage++
          this.getTeachers(this.filter)
        }
      }
    },
    getTeachers (filter) {
      this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', filter, r => {
        if (r.data && r.data.length>0) {
          this.teacherList = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        }
      })
    },
    getEliteTeachers () {
      this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', {pageNo: 1, pageSize: 4, delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          this.eliteTeacherList = r.data
        }
      })
    },
    teacher_detail (id) {
      this.$router.push({path: '/byl/teacherDetail/'+ id})
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/teacher/list.vue